<script>
  import { CustomFields } from '@client/components/custom-fields';
  import { Field, FieldActions, FieldHeader, FieldLabel, FieldValue } from '@client/components/fields/standalone/base';

  import { hasCapability } from '@client/stores/user';

  import { deepCopyArray } from '@common/utils/arrays';

  export let id = null;
  export let label = null;
  export let fields = [];

  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let readonly = false;
  export let editing = false;

  export let showActions = true;

  export let onUpdate = () => {};

  let items = deepCopyArray(fields);
  let disableSubmit = true;

  const onEdit = () => {
    editing = true;
  };

  const onCancel = () => {
    editing = false;
    items = deepCopyArray(fields);
  };

  const onSave = () => {
    editing = false;

    if (onUpdate) {
      onUpdate(id, label, items);
      fields = deepCopyArray(items);
    }
  };

  $: readOnly = !editing && hasCapability('manage', 'manage:users');
  $: disableSubmit = JSON.stringify(items) === JSON.stringify(fields);
</script>

<Field bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} />
    <FieldActions bind:readonly bind:editing bind:disableSubmit {onSave} {onEdit} {onCancel} {showActions} />
  </FieldHeader>
  <FieldValue {showActions} fill>
    <CustomFields bind:fields={items} bind:readOnly bind:editing />
  </FieldValue>
  {#if !editing}
    <slot />
  {/if}
</Field>

<style lang="scss" src="./custom-fields.scss"></style>
